<template>
  <!-- 投票管理-新增投票队伍 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="投票队伍"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        v-if="dataForm"
        ref="dataForm"
        label-width="80px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="name" label="队伍名称">
          <el-input
            placeholder="请选择队伍"
            maxlength="100"
            show-word-limit
            :disabled="true"
            v-model="dataForm.name"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="is_pk" label="进行PK">
          <el-select v-model="dataForm.is_pk" placeholder="队伍输赢">
            <el-option :value="0" label="未PK"></el-option>
            <el-option :value="1" label="正在PK"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="room_id" label="roll房id">
          <el-input
            placeholder="请输入roll房id"
            maxlength="100"
            v-model="dataForm.room_id"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="tick_num" label="队伍票数">
          <el-input
            placeholder="请输入队伍票数"
            maxlength="100"
            v-model="dataForm.tick_num"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="is_win" label="队伍输赢">
          <el-select v-model="dataForm.is_win" placeholder="队伍输赢">
            <el-option :value="0" label="待定"></el-option>
            <el-option :value="2" label="输"></el-option>
            <el-option :value="1" label="赢"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button
            v-if="dataForm.status != 2"
            type="primary"
            @click="submit(dataForm.id)"
            :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { getData, delApiData, getApiData, postApiData, patchApiData } from '../../http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dataForm: {
        name: '',
        is_pk: 0,
        room_id:0,
        tick_num: 0,
        is_win: 0
      },
      replyRules: {//回复弹窗规则验证
        reply: [
          {
            required: true,
            message: '回复内容不能为空',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.dataForm = this.fromInfo
      }
    },
  },
  created() {
  },
  methods: {
    submit(id) {
      //保存任务
      //表单验证后发起请求
      this.buttonLoading = true
      this.dataForm.room = id
      let params = this.dataForm
      postApiData(`major_set`, params).then(res => {
        this.$message.success(res.message)
        this.$emit('refresh')
        this.closeDialog()
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>